exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active-nav-link[data-v-68f4b7f8]{text-decoration:underline}", ""]);

// exports
